import { generator } from  '../event-listener';

export const OnBeforeFetch = generator('onBeforeFetch');
export const OnAfterFetch = generator('onAfterFetch');
export const OnAbort = generator('onAbort');
